export const SET_WEBSITE_MODE = "SET_WEBSITE_MODE"
export const SET_CURRENT_FILE_KEY = "SET_CURRENT_FILE_KEY"
export const SET_DATA_STATUS = "SET_DATA_STATUS"
